
import { PropType, defineComponent } from 'vue'

export default defineComponent({
    props: {
        startColor: {
            type: String as PropType<string>,
            default: () => '#EBCF8B'
        },
        endColor: {
            type: String as PropType<string>,
            default: () => '#A28342'
        }
    }
})
